import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preset", "loading"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/SkeletonLoader/SkeletonLoader.js",
  _this = this;
import React from 'react';
import skeletonPresets from './preset';
import { testIdProps } from '../../helpers';
var presetTypes = Object.keys(skeletonPresets);
var SkeletonLoader = function SkeletonLoader(_ref) {
  var preset = _ref.preset,
    loading = _ref.loading,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Skeleton = skeletonPresets[preset];
  if (!Skeleton) {
    throw '`preset` prop missing or incorrect. It must be one of ' + presetTypes.join(', ');
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(Skeleton, _extends({}, testIdProps(rest), {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 12
      }
    }));
  } else {
    return rest.children;
  }
};
export default SkeletonLoader;